// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._sideNav_xdqp4_1 {
  /* Colors */
  --pa-comparison-list-side-nav-ghost-background-color-inner: var(
    --pa-comparison-list-side-nav-ghost-background-color,
    var(--perxis-auto-root-first-color-inner)
  );
  /* End Colors */
  /* Position */
  --pa-comparison-list-side-nav-right-inner: var(--pa-comparison-list-side-nav-padding, 0);
  /* End Position */
  --perxis-auto-button-ghost-background-color: var(--pa-comparison-list-side-nav-ghost-background-color-inner);
  position: absolute;
  display: flex;
  flex-direction: column;
  right: var(--pa-comparison-list-side-nav-right-inner);
  top: 50%;
  z-index: 1;
  transform: translateY(-50%);
  row-gap: 18px;
}
._sideNav_xdqp4_1[data-list-length="0"], ._sideNav_xdqp4_1[data-list-length="1"], ._sideNav_xdqp4_1[data-list-length="2"] {
  display: none;
}
@media (min-width: 1200px) {
  ._sideNav_xdqp4_1[data-list-length="4"] {
    display: none;
  }
}
@media (min-width: 992px) {
  ._sideNav_xdqp4_1[data-list-length="3"] {
    display: none;
  }
}
._sideNav_xdqp4_1._sideNav--hidden_xdqp4_34 {
  display: none;
}
._sideNav_xdqp4_1 ._sideNav__button_xdqp4_37 {
  /* Sizes */
  --pa-comparison-list-side-nav-button-height-inner: var(--pa-comparison-list-side-nav-button-height, 50px);
  --pa-comparison-list-side-nav-button-width-inner: var(--pa-comparison-list-side-nav-button-width, 50px);
  /* End Sizes */
  /* Colors */
  --pa-comparison-list-side-nav-button-color-inner: var(
    --pa-comparison-list-side-nav-button-color,
    var(--perxis-auto-root-second-color-inner)
  );
  --pa-comparison-list-side-nav-button-disabled-color-inner: var(
    --pa-comparison-list-side-nav-button-disabled-color,
    var(--perxis-auto-root-first-color-inner)
  );
  --pa-comparison-list-side-nav-button-hover-color-inner: var(
    --pa-comparison-list-side-nav-button-hover-color,
    var(--perxis-auto-root-first-color-inner)
  );
  --pa-comparison-list-side-nav-button-border-color-inner: var(
    --pa-comparison-list-side-nav-button-border-color,
    var(--perxis-auto-root-second-color-inner)
  );
  --pa-comparison-list-side-nav-button-disabled-border-color-inner: var(
    --pa-comparison-list-side-nav-button-disabled-border-color,
    var(--perxis-auto-root-sixth-color-inner)
  );
  --pa-comparison-list-side-nav-button-hover-border-color-inner: var(
    --pa-comparison-list-side-nav-button-hover-border-color,
    var(--perxis-auto-root-third-color-inner)
  );
  --pa-comparison-list-side-nav-button-background-color-inner: var(
    --pa-comparison-list-side-nav-button-background-color,
    var(--perxis-auto-root-first-color-inner)
  );
  --pa-comparison-list-side-nav-button-disabled-background-color-inner: var(
    --pa-comparison-list-side-nav-button-disabled-background-color,
    var(--perxis-auto-root-sixth-color-inner)
  );
  --pa-comparison-list-side-nav-button-hover-background-color-inner: var(
    --pa-comparison-list-side-nav-button-hover-background-color,
    var(--perxis-auto-root-third-color-inner)
  );
  /* End Colors */
  /* Box Shadow */
  --pa-comparison-list-side-nav-button-box-shadow-inner: var(
    --pa-comparison-list-side-nav-button-box-shadow,
    0px 0px 10px 0px rgba(38, 38, 38, 0.1)
  );
  /* End Box Shadow */
  /* Border */
  --pa-comparison-list-side-nav-button-border-width-inner: var(
    --pa-comparison-list-side-nav-button-border-width,
    2px
  );
  --pa-comparison-list-side-nav-button-border-radius-inner: var(
    --pa-comparison-list-side-nav-button-border-radius,
    8px
  );
  /* End Border */
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  outline: 0;
  cursor: pointer;
  height: var(--pa-comparison-list-side-nav-button-height-inner);
  width: var(--pa-comparison-list-side-nav-button-width-inner);
  color: var(--pa-comparison-list-side-nav-button-color-inner);
  background-color: var(--pa-comparison-list-side-nav-button-background-color-inner);
  box-shadow: var(--pa-comparison-list-side-nav-button-box-shadow-inner);
  border-style: solid;
  border-width: var(--pa-comparison-list-side-nav-button-border-width-inner);
  border-color: var(--pa-comparison-list-side-nav-button-border-color-inner);
  border-radius: var(--pa-comparison-list-side-nav-button-border-radius-inner);
  transition: background-color 0.1s linear, border-color 0.1s linear, color 0.1s linear;
}
._sideNav_xdqp4_1 ._sideNav__button_xdqp4_37:disabled {
  color: var(--pa-comparison-list-side-nav-button-disabled-color-inner);
  background-color: var(--pa-comparison-list-side-nav-button-disabled-background-color-inner);
  border-color: var(--pa-comparison-list-side-nav-button-disabled-border-color-inner);
}
@media not all and (hover: none) {
  ._sideNav_xdqp4_1 ._sideNav__button_xdqp4_37:not(:disabled):hover {
    color: var(--pa-comparison-list-side-nav-button-color-inner);
    background-color: var(--pa-comparison-list-side-nav-button-background-color-inner);
    border-color: var(--pa-comparison-list-side-nav-button-border-color-inner);
  }
  ._sideNav_xdqp4_1 ._sideNav__button_xdqp4_37:not(:disabled):active {
    color: var(--pa-comparison-list-side-nav-button-hover-color-inner);
    background-color: var(--pa-comparison-list-side-nav-button-hover-background-color-inner);
    border-color: var(--pa-comparison-list-side-nav-button-hover-border-color-inner);
  }
}
@media (hover: hover) {
  ._sideNav_xdqp4_1 ._sideNav__button_xdqp4_37:not(:disabled):hover {
    color: var(--pa-comparison-list-side-nav-button-hover-color-inner);
    background-color: var(--pa-comparison-list-side-nav-button-hover-background-color-inner);
    border-color: var(--pa-comparison-list-side-nav-button-hover-border-color-inner);
  }
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
